import { useCallback } from 'react';
import '../../../../css/tabs.less';
import { ClipBoardProvider } from '../../ClipBoardProvider';
import { SYSTEM_ROLES } from '../../constants/system';
import { useRouting, useTabRouting } from '../../hooks/route';
import { useAuth } from '../AuthProvider';
import { useNotificationDispatch } from '../notifications/NotificationProvider';
import TabContent from './TabContent';
import Tabs from './Tabs';
import { useTabs, useTabsDispatch } from './TabsProvider';

type TabContentProps = {
    isTenantSelectorOpen: boolean;
};

export const TabsSection = ({ isTenantSelectorOpen }: TabContentProps) => {
    const { tenant } = useAuth();

    const { tabs, activeTabKey } = useTabs();
    const dispatchTabs = useTabsDispatch();
    const { closeTab, selectTab } = useRouting();

    const dispatchNotification = useNotificationDispatch();

    const onError = useCallback(
        (error: unknown) => {
            dispatchNotification({
                type: 'notifyError',
                payload: { error },
            });
        },
        [dispatchNotification],
    );

    const role = tenant?.role;
    const environmentsIsOn = tenant?.tenantSettings?.environments ?? false;
    const isAdministrator = role === SYSTEM_ROLES.administrator.developerName;

    /**
     * Subscribe to route changes and open tabs based on the url
     */
    useTabRouting(role, environmentsIsOn, isAdministrator, onError, dispatchTabs);

    return (
        <div className="tabs flex-column">
            <ClipBoardProvider>
                <Tabs
                    tabs={tabs}
                    activeTabKey={activeTabKey}
                    onSelect={selectTab}
                    onClose={closeTab}
                />
                <div className="tab-content-wrapper">
                    {tabs.map((tab) => (
                        <TabContent
                            tab={tab}
                            isActive={tab.key === activeTabKey}
                            key={tab.key}
                            isTenantSelectorOpen={isTenantSelectorOpen}
                        />
                    ))}
                </div>
            </ClipBoardProvider>
        </div>
    );
};

export default TabsSection;
